export enum RequestType {
    DEMO,
    OFFER,
    LISTING,
    CUSTOMER
}
